import * as React from 'react';
import {ControlledInputs} from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import {ScopeValidationItem} from '../../../../resource/resources/validation/types';

export const ValidationScopeSectionComponent= ({scope}: {
    scope: ScopeValidationItem;
}) => {

    const getValue = () => {
        return 'No Scope';
    };

    return <ControlledInputs.String nullable={false} label={`Scope`} value={getValue()} readOnly={true}/>;
};
